import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const catalogSelector = createSelector(rootSelector, state => state.catalog);

export const categoryPathLabelsSelector = createSelector(catalogSelector, catalog => catalog?.categoryPathLabels);
export const packageMapSelector = createSelector(catalogSelector, catalog => catalog?.packageMap);
